export enum FactorIndexEnum {
    FACTOR_ONE = 1,
    FACTOR_TWO = 2
}